var React = require('react');

function IcLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z","fill":"currentColor"}));
}

IcLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcLeft;

IcLeft.default = IcLeft;
